import { Button, Flex } from "antd";
import React, { useState } from "react";
import CustomModal from "../../../../components/modal/CustomModal";
import CustomInput from "../../../../components/input/CustomInput";
import { IconAlertSquareRounded, IconTicket } from "@tabler/icons-react";
import api from "../../../../api";
import { useToast } from "../../../../components/toast/toast";

const GiveLottery = ({ data }) => {
  const [showModal, setShowModal] = useState(false);
  const [formData, setFormData] = useState({
    phone: "",
    quantity: 0,
    unit_price: 0,
    message: data?.config?.sms || "",
  });
  const toast = useToast();

  const inputHandler = (key, value) => {
    setFormData((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  const clearHandler = () => {
    setShowModal(false);
    setFormData({
      phone: "",
      quantity: 0,
      unit_price: parseInt(data?.ticket_price) || 0,
      message: data?.config?.sms || "",
    });
  };

  const submitHandler = async () => {
    const res = await api.give_lottery(data.id, {
      phone_number: formData.phone,
      quantity: formData.quantity,
      unit_price: formData.unit_price,
      sms: formData.message,
    });
    // console.log("submit res --->", res);
    if (res.status === 201) {
      clearHandler();
      toast("Сугалаа амжилттай өгөгдлөө", "success");
    } else {
      // console.error("Алдаа гарлаа:", res);
      toast(res.data?.message || "Алдаа гарлаа.", "error");
    }
  };

  return (
    <>
      <Button
        variant="dashed"
        color="primary"
        style={{ padding: "0px 20px" }}
        onClick={() => setShowModal(true)}
      >
        <IconTicket size={18} strokeWidth={1.5} />
        Сугалаа өгөх
      </Button>

      {/* --- GIVE modal --- */}
      <CustomModal
        centered
        title={"Сугалаа өгөх"}
        open={showModal}
        onOk={submitHandler}
        onCancel={() => {
          clearHandler();
        }}
        disabled={
          !formData.phone ||
          Number(formData.quantity) < 1 ||
          !formData.message ||
          Number(formData.unit_price) < 0
        }
      >
        <Flex vertical gap={"10px"}>
          <CustomInput
            title={"Утасны дугаар"}
            required
            value={formData.phone}
            maxLength={8}
            onChange={(e) => inputHandler("phone", e.target.value)}
          />
          <CustomInput
            required
            title={"Тоо ширхэг"}
            type="inputNumber"
            value={formData.quantity}
            onChange={(e) => inputHandler("quantity", e)}
          />

          <CustomInput
            required
            title={"Нэгж үнэ"}
            value={formData.unit_price}
            onChange={(e) => inputHandler("unit_price", e.target.value)}
          />
          <CustomInput
            required
            title={"Мессеж"}
            value={formData.message}
            onChange={(e) => inputHandler("message", e.target.value)}
          />
          <p style={{ fontSize: "12px", color: "#666" }}>
            Мессеж очихдоо {"{QTY}"} энэ тэмдэгтийн оронд тоо ширхэг очно.
          </p>

          <Flex
            style={{
              backgroundColor: "#fff6cc",
              padding: "15px",
              borderRadius: "4px",
            }}
            align="center"
            gap={"10px"}
          >
            <IconAlertSquareRounded
              strokeWidth={1.5}
              color="#5f5c73"
              style={{
                width: "20px",
                height: "20px",
                padding: 0,
                margin: 0,
                flexShrink: 0,
              }}
            />

            <p style={{ color: "#5f5c73", textAlign: "justify" }}>
              Мессеж хэсэг нь сугалааны үндсэн мессеж харуулж байгаа ба мессеж
              сольж явуулж болно.
            </p>
          </Flex>
        </Flex>
      </CustomModal>
    </>
  );
};

export default GiveLottery;
